/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PseudonymSuggestionCheckAvailableAliases {
  BUTTON_CONFIRM = 'button-confirm',
  CARD_APPOINTMENTS_TITLE = 'card-appointments-title',
  CONTEXTUAL_BAR_SUGGESTION_CHECK_AVAILABLE = 'contextual-bar-suggestion-check-available',
  FIELD_DATE = 'field-date',
  FIELD_OBSERVATION = 'field-observation',
  FIELD_PERIOD = 'field-period',
  FIELD_UPLOAD = 'field-upload',
  FILE_UPLOADER = 'file-uploader',
  FORM_REQUEST = 'form-request',
  GLOBAL_ACTIONS_MODAL = 'global-actions-modal',
  INPUT_DATE = 'input-date',
  LAYOUT_SUGGESTION_CHECK_AVAILABLE = 'layout-suggestion-check-available',
  LAYOUT_SUGGESTION_CHECK_AVAILABLE_CONTENT = 'layout-suggestion-check-available-content',
  MAPPER_AVATAR = 'mapper-avatar',
  PANEL_CONTENT = 'panel-content',
  PANEL_ITEM = 'panel-item',
  PANEL_PERIOD = 'panel-period',
  PANEL_SUGGESTION_CHECK_AVAILABLE = 'panel-suggestion-check-available',
  SEGMENTED_CONTROL_PERIOD = 'segmented-control-period',
  TEXT_AREA_OBSERVATION = 'text-area-observation',
  TEXT_PERIOD = 'text-period',
}
export { PseudonymSuggestionCheckAvailableAliases };
